//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";

import SearchHeader from "./components/SearchHeader";
import TagFilters from "./components/TagFilters";
import ResultCountText from "./components/ResultCountText";
import Loader from "./components/Loader";
import CardList from "./components/CardList";
import Map from "./components/Map";

export default {
	name: "LocationsListingApp",
	components: {
		SearchHeader,
		TagFilters,
		ResultCountText,
		Loader,
		CardList,
		Map,
	},
	data() {
		return {
			ready: false,
			greeting: "Hello, blue world!",
			presearchZipcode: null,
		};
	},
	computed: {
		...mapGetters([
			"isLoading",
			"isLoadingMore",
			"googleInitialized",
			"activeLocations",
			"totalLocations",
			"map",
			"placesService",
		]),
	},
	watch: {
		// Below watches isLoading state property to trigger the map's addMarker's function whenever a new request is returned
		'$store.state.isLoading': function() {
			if(!this.isLoading && this.map) {
				this.$nextTick(() => {
					this.$refs.map.addMarkers();
				});
			}
		},
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		...mapActions([
			"sendLocationRequest",
			"initGoogle"
		]),
		async checkForBrowserGeolocation() {
			return new Promise((resolve) => {
				if (!!navigator.geolocation) {
					let lat;
					let lng;
					const options = {
						enableHighAccuracy: true,
						timeout: 5000,
						maximumAge: 0
					}
					const success = async (pos) => {
						lat = pos.coords.latitude;
						lng = pos.coords.longitude;
						this.setStateValue(['lat', lat ]);
						this.setStateValue(['lng', lng ]);
						await this.sendLocationRequest();
						this.ready = true;
						resolve();
					}
					const error = async (err) => {
						console.warn(`ERROR(${err.code}): ${err.message}`);
						await this.sendLocationRequest();
						this.setStateValue(['isLoading', false ]);
						this.ready = true;
						resolve();
					}
					navigator.geolocation.getCurrentPosition(success, error, options);	
				} else {
					this.setStateValue(['isLoading', false ]);
					resolve();
				}
			})
		},
		// Below triggers the map's addMarker's function for the first time after the map property is set
		triggerFirstMarkers() {
			if(this.map && !this.isLoading) {
				this.$nextTick(() => {
					this.$refs.map.addMarkers();
				});
			}
		},
	},
	async created() {
		this.setStateValue(['requestEndpoint', this.$root.apiEndpoint]);
		await this.initGoogle();
		if (!!this.$root.zipcode) {
			this.presearchZipcode = this.$root.zipcode;
		}
		await this.checkForBrowserGeolocation();
	},
	async mounted() {}
};
